// extracted by mini-css-extract-plugin
export default {"container":"SubIssueTypeIndicator-module__container--x9PE7"};